import React from "react";

function Support() {
  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: Arial, Helvetica, sans-serif;
          background: #f5f8fc;
          color: #263238;
          line-height: 1.7;
        }

        header {
          background: linear-gradient(135deg, #00aeef, #0077b6);
          color: white;
          padding: 65px 20px;
          text-align: center;
        }

        .logo {
          font-size: 34px;
          font-weight: bold;
          letter-spacing: 0.5px;
          margin-bottom: 12px;
        }

        header p {
          max-width: 650px;
          margin: auto;
          font-size: 17px;
        }

        .container {
          max-width: 1100px;
          margin: 40px auto;
          padding: 0 20px;
        }

        .intro {
          background: white;
          padding: 30px;
          border-radius: 15px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          margin-bottom: 30px;
        }

        .intro h2,
        .faq h2 {
          color: #0077b6;
          margin-bottom: 12px;
        }

        .support-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 22px;
        }

        .card {
          background: white;
          padding: 28px;
          border-radius: 15px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
        }

        .card h3 {
          color: #0077b6;
          margin-bottom: 12px;
          font-size: 21px;
        }

        .card p {
          margin-bottom: 12px;
        }

        .card ul {
          padding-left: 22px;
          margin-bottom: 12px;
        }

        .card li {
          margin-bottom: 8px;
        }

        .card a,
        footer a {
          color: #0077b6;
          font-weight: bold;
        }

        .contact-section {
          background: linear-gradient(135deg, #00aeef, #0077b6);
          color: white;
          padding: 35px;
          border-radius: 15px;
          margin-top: 30px;
          text-align: center;
        }

        .contact-section h2 {
          margin-bottom: 12px;
        }

        .email-button {
          display: inline-block;
          background: white;
          color: #0077b6;
          padding: 12px 25px;
          margin-top: 18px;
          border-radius: 30px;
          text-decoration: none;
          font-weight: bold;
        }

        .email-button:hover {
          background: #eaf8ff;
        }

        .faq {
          margin-top: 30px;
        }

        details {
          background: white;
          margin-bottom: 12px;
          padding: 18px 22px;
          border-radius: 10px;
          box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
        }

        summary {
          cursor: pointer;
          font-weight: bold;
          color: #263238;
        }

        details p {
          margin-top: 12px;
        }

        footer {
          text-align: center;
          background: #172b4d;
          color: white;
          padding: 30px 20px;
          margin-top: 50px;
        }

        footer a {
          color: #8edcff;
          text-decoration: none;
        }

        @media (max-width: 700px) {
          .support-grid {
            grid-template-columns: 1fr;
          }

          .logo {
            font-size: 28px;
          }

          header {
            padding: 45px 20px;
          }

          .card,
          .intro {
            padding: 22px;
          }
        }
      `}</style>

      <header>
        <h1 className="">FindMe JoinMe</h1>
        

        <p>Find it. Join it. Grow with it.</p>

        <p style={{ marginTop: "10px" }}>
          Welcome to the official FindMe JoinMe Support Center.
          We are here to help you get the most out of the app.
        </p>
      </header>

      <main className="container">

        {/* Introduction */}
        <section className="intro">
          <h2>How can we help you?</h2>

          <p>
            FindMe JoinMe is a location-based discovery platform that helps
            users find nearby opportunities, services, products, and offers.
            Users can explore different categories, discover useful listings,
            create posts, and connect with people or businesses.
          </p>

          <p style={{ marginTop: "12px" }}>
            If you need assistance with your account, a post, a report,
            privacy, or any technical issue, our support team is available
            to help.
          </p>
        </section>

        {/* Support Cards */}
        <section className="support-grid">

          {/* General Technical Support */}
          <article className="card">
            <h3>📱 General Technical Support</h3>

            <p>
              Having trouble using FindMe JoinMe? We can help with technical
              problems and app-related questions.
            </p>

            <ul>
              <li>App crashes or unexpected errors</li>
              <li>Login or registration problems</li>
              <li>App loading or performance issues</li>
              <li>Location or nearby listings problems</li>
              <li>Categories or search not working</li>
              <li>Issues with app features</li>
              <li>Problems after an app update</li>
            </ul>

            <p>
              Please include your device model, operating system, and a
              description of the problem.
            </p>
          </article>

          {/* Account Problems */}
          <article className="card">
            <h3>👤 Account Problems</h3>

            <p>
              Contact us if you are experiencing difficulties with your
              FindMe JoinMe account.
            </p>

            <ul>
              <li>Unable to create an account</li>
              <li>Unable to log in</li>
              <li>Problems receiving verification codes</li>
              <li>Profile information issues</li>
              <li>Account access problems</li>
              <li>Problems updating account details</li>
              <li>Questions about your account status</li>
            </ul>

            <p>
              For your security, do not send your password or verification
              codes by email.
            </p>
          </article>

          {/* Post Problems */}
          <article className="card">
            <h3>📢 Post and Listing Problems</h3>

            <p>
              If you are having trouble creating, viewing, or managing a
              post, please contact our support team.
            </p>

            <ul>
              <li>Unable to create a post</li>
              <li>Problems uploading images</li>
              <li>Post not appearing correctly</li>
              <li>Unable to edit or delete a post</li>
              <li>Incorrect category or listing details</li>
              <li>Duplicate or unwanted listings</li>
              <li>Problems viewing nearby posts</li>
            </ul>

            <p>
              If possible, provide the relevant post details and screenshots.
            </p>
          </article>

          {/* Report */}
          <article className="card">
            <h3>🚩 Report a Post or User</h3>

            <p>
              We want FindMe JoinMe to remain useful and respectful. You can
              contact us to report content or activity that violates our rules.
            </p>

            <ul>
              <li>Spam or misleading listings</li>
              <li>Fraudulent or suspicious activity</li>
              <li>Inappropriate content</li>
              <li>Harassment or abusive behavior</li>
              <li>Misleading information</li>
              <li>Other content that requires review</li>
            </ul>

            <p>
              Please provide the post title, username, relevant details,
              and a description of the concern.
            </p>
          </article>

          {/* Privacy */}
          <article className="card">
            <h3>🔒 Privacy Questions</h3>

            <p>
              We respect your privacy and take questions about personal
              information seriously.
            </p>

            <ul>
              <li>Questions about personal information</li>
              <li>Location permission concerns</li>
              <li>Questions about information collection</li>
              <li>Requests concerning your personal data</li>
              <li>Questions about privacy practices</li>
              <li>Privacy-related complaints</li>
            </ul>

            <p>
              For more information, please review our Privacy Policy.
            </p>

            <p>
              <a href="/privacy-policy">
                View Privacy Policy
              </a>
            </p>
          </article>

          {/* Account Deletion */}
          <article className="card">
            <h3>🗑️ Account Deletion</h3>

            <p>
              If you want to permanently delete your FindMe JoinMe account,
              submit a deletion request to our support team.
            </p>

            <p>
              Please send an email from the address associated with your
              account and include:
            </p>

            <ul>
              <li>Subject: Account Deletion Request</li>
              <li>Your registered email address</li>
              <li>Your username, if available</li>
              <li>A clear request to delete your account</li>
            </ul>

            <p>
              We may need to verify account ownership before processing a
              deletion request. Deletion may be permanent, and some
              information may need to be retained where required by law.
            </p>
          </article>

        </section>

        {/* Contact Section */}
        <section className="contact-section">
          <h2>Contact FindMe JoinMe Support</h2>

          <p>
            We are happy to help with your questions, feedback, technical
            problems, and account-related concerns.
          </p>

          <p style={{ marginTop: "10px" }}>
            Email our support team and provide as much relevant information
            as possible.
          </p>

          <a
            className="email-button"
            href="mailto:findmejoinme@gmail.com"
          >
            Email Support
          </a>

          <p style={{ marginTop: "18px" }}>
            <strong>Email:</strong> findmejoinme@gmail.com
          </p>
        </section>

        {/* FAQ */}
        <section className="faq">
          <h2>Frequently Asked Questions</h2>

          <details>
            <summary>What is FindMe JoinMe?</summary>

            <p>
              FindMe JoinMe is a location-based discovery app that helps
              users discover nearby jobs, property listings, services,
              products, offers, and other useful opportunities. Users can
              browse categories and create posts.
            </p>
          </details>

          <details>
            <summary>How do I contact support?</summary>

            <p>
              Contact our support team by emailing
              {" "}
              findmejoinme@gmail.com.
              Please explain your issue clearly and include relevant details.
            </p>
          </details>

          <details>
            <summary>
              What information should I include in a support email?
            </summary>

            <p>
              Include a description of the problem, your device model,
              operating system, and screenshots if helpful. Never include
              your password or verification codes.
            </p>
          </details>

          <details>
            <summary>How can I report a post or user?</summary>

            <p>
              If the app provides a reporting option, use it to report the
              relevant content. You may also contact our support team with
              the post details and a description of the issue.
            </p>
          </details>

          <details>
            <summary>How can I delete my account?</summary>

            <p>
              Send an account deletion request to
              {" "}
              findmejoinme@gmail.com.
              Include your registered email address and your request to
              delete the account. We may need to verify ownership before
              processing your request.
            </p>
          </details>

          <details>
            <summary>How can I ask a privacy question?</summary>

            <p>
              Email findmejoinme@gmail.com with your privacy-related
              question. You may also review our Privacy Policy for
              additional information.
            </p>
          </details>

          <details>
            <summary>How long does support take to respond?</summary>

            <p>
              We aim to review support requests and respond as soon as
              reasonably possible. Response times may vary depending on
              the nature and complexity of the issue.
            </p>
          </details>
        </section>

      </main>

      {/* Footer */}
      <footer>
        <p>© 2026 FindMe JoinMe. All rights reserved.</p>

        <p style={{ marginTop: "10px" }}>
          <a href="/privacy-policy">
            Privacy Policy
          </a>

          {" "} | {" "}

          <a href="/support">
            Support
          </a>
        </p>

        <p style={{ marginTop: "10px" }}>
          Find it. Join it. Grow with it.
        </p>
      </footer>
    </>
  );
}




export default Support;